import React from 'react';
import { Link } from 'react-router-dom';
import projMan from '../../images/projSub.jpg';
import blog4 from '../../images/blog-details/comments-author/img-2.jpg';
import blog5 from '../../images/blog-details/comments-author/img-3.jpg';
import blog6 from '../../images/blog-details/author.jpg';
import blogs from '../../api/blogs';
import { useParams } from 'react-router-dom';
import Secretary from '../../images/studentReq.jpg';

const DigitalMarketingSpecialist = (props) => {
    const { slug } = useParams();
    const BlogDetails = blogs.find(item => item.slug === slug);

    const submitHandler = (e) => {
        e.preventDefault();
    };

    return (
        <section className="blog-single-section section-padding">
            <div className="container">
                <div className="row">
                    <div className={`col col-lg-9 col-12 ${props.blRight}`}>
                        <div className="blog-content">
                            <div className="tag-share">
                                <div className="post format-standard-image">
                                    <div className="entry-media">
                                        <img src={Secretary} alt="" />
                                    </div>
                                    <ul className="entry-meta">
                                        <li><Link to="">FFSD GROUP</Link></li>
                                        <li><Link to="">Location: Abuja</Link></li>
                                        <li><Link to="">Employment Type: Full-Time</Link></li>
                                        <li><Link to="">Salary: N250,000 - N300,000</Link></li>
                                    </ul>
                                    
                                    <h2>Job Title: Digital Marketing Specialist</h2>
                                    
                                    <h3>About the Role</h3>
                                    <p>
                                        We are seeking an experienced and results-driven Digital Marketing Specialist to lead and execute our digital marketing initiatives across multiple platforms. The ideal candidate will have strong expertise in social media management, content marketing, digital advertising, analytics, and lead generation, with a proven ability to drive brand awareness, engagement, and digital sales.
                                    </p>
                                    <p>
                                        This role requires a highly creative, analytical, and trend-conscious professional who can align digital strategies with the brand's identity and business objectives.
                                    </p>
                                    
                                    <div className="important-notice" style={{backgroundColor: '#fff8e1', padding: '15px', borderLeft: '4px solid #ff9800', margin: '20px 0'}}>
                                        <h4 style={{color: '#d84315', marginTop: '0'}}>⚠️ Mandatory Requirement</h4>
                                        <p style={{marginBottom: '0'}}>
                                            <strong>Proficiency in Zoho Campaign is a critical requirement for this role.</strong> Candidates without hands-on experience in Zoho Campaign for email marketing, automation, and CRM-driven lead management will not be considered.
                                        </p>
                                    </div>
                                    
                                    <h3>Key Responsibilities</h3>
                                    <p>
                                        • Develop, implement, and strategically manage the company's social media presence across platforms including Instagram, Facebook, LinkedIn, Threads, and other relevant channels.<br />
                                        • Create engaging, high-quality, and trend-driven content, including graphics, videos, blog posts, and captions.<br />
                                        • Plan, manage, and optimize social media campaigns, including paid advertising, boosted posts, and targeted audience engagement.<br />
                                        • Track, analyze, and report campaign performance using Google Analytics and other digital marketing metrics to measure ROI and optimize results.<br />
                                        • Produce consistent blog posts and content marketing materials aligned with the brand's voice and messaging.<br />
                                        • Effectively utilize Zoho Campaign for:<br />
                                        &nbsp;&nbsp;&nbsp;○ Email marketing campaigns<br />
                                        &nbsp;&nbsp;&nbsp;○ Lead nurturing and marketing automation<br />
                                        &nbsp;&nbsp;&nbsp;○ Audience segmentation<br />
                                        &nbsp;&nbsp;&nbsp;○ Campaign performance analysis<br />
                                        &nbsp;&nbsp;&nbsp;○ CRM-based lead generation and management<br />
                                        • Identify, analyze, and strengthen target audience engagement using data-driven insights.<br />
                                        • Monitor digital trends, competitor activities, and emerging tools to ensure brand relevance and competitiveness.<br />
                                        • Collaborate closely with marketing and management teams to maintain brand alignment and communication consistency.<br />
                                        • Convert digital leads into potential customers through effective digital sales funnels and engagement strategies.<br />
                                        • Conduct keyword research and implement SEO strategies to improve online visibility.<br />
                                        • Optimize blog and social media content for search engine performance.
                                    </p>

                                    <h3>Required Skills & Qualifications</h3>
                                    <p>
                                        • Proven experience as a Social Media Manager, Digital Marketing Specialist, or Content Strategist.<br />
                                        • <strong>Mandatory:</strong> Demonstrated proficiency in Zoho Campaign, including email automation, campaign creation, segmentation, analytics, and CRM integration.<br />
                                        • Strong working knowledge of:<br />
                                        &nbsp;&nbsp;&nbsp;○ Google Analytics<br />
                                        &nbsp;&nbsp;&nbsp;○ Paid advertising and content boosting<br />
                                        &nbsp;&nbsp;&nbsp;○ Social media management and scheduling tools<br />
                                        &nbsp;&nbsp;&nbsp;○ Content creation and publishing workflows<br />
                                        • Excellent understanding of traffic growth strategies across Instagram, Facebook, LinkedIn, and Threads.<br />
                                        • Strong writing and storytelling skills for blog content, captions, and brand messaging.<br />
                                        • In-depth knowledge of digital sales funnels, audience targeting, and lead conversion strategies.<br />
                                        • Ability to identify digital trends and translate them into relevant, high-performing content.<br />
                                        • Self-motivated, creative, and proactive with a strong sense of initiative.<br />
                                        • Excellent communication, analytical, and time management skills.
                                    </p>

                                    <h3>Preferred Qualities</h3>
                                    <p>
                                        • Ability to work independently with a strong sense of ownership and accountability.<br />
                                        • High attention to detail with a passion for creativity and innovation.<br />
                                        • Proven experience driving measurable brand growth, engagement, and conversions.<br />
                                        • Strong responsibility, reliability, and results-oriented mindset.
                                    </p>

                                    <h3>How to Apply</h3>
                                    <p>
                                        Interested candidates should submit their CV, portfolio, and links to social media pages managed to:<br />
                                        📧 <a href="mailto:careers@ffsdgroup.com">careers@ffsdgroup.com</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DigitalMarketingSpecialist;